/*
 * COPYRIGHT: EUMETSAT 2018
 * LICENSE: PROPRIETARY
 * PROJECT: WMS
 * 
 * All information contained herein is, and remains the property of EUMETSAT.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * EUMETSAT.
 */

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

export enum TokenMode {
    Header = 0,
    UrlParam = 1
}

export interface ProtectedService {
    url: string;
    tokenMode: TokenMode;
    errorHandler?: Function;
}

@Injectable()
export class AuthResourceHandler {

    private authErrors = new Subject();
    private protectedServices: ProtectedService[] = [];

    constructor() {

    }

    addProtectedService(service: ProtectedService) {
        this.protectedServices.push({
            ...service,
            url: service.url.toLowerCase()
        });
    }

    getAuthErrors() {
        return this.authErrors.asObservable();
    }

    getProtectedServices(): Readonly<ProtectedService[]> {
        return this.protectedServices;
    }

    getErrorHandler() {
        return (err) => {
            this.authErrors.next(err);
        };
    }
}



// WEBPACK FOOTER //
// ./src/main/services/user/auth-resource-handler.ts